import Footer from "../Layout/Footer";
import LahzaHero from "./LahzaHero";

const Lahza = () => {
  return (
    <>
      <LahzaHero />
      <Footer />
    </>
  );
};

export default Lahza;
